<div class="bg-main-container font-white border-radius-10 p-2">
  <div class="container py-4">
    <!-- Header Section -->
    <div class="header-section mb-4 d-flex justify-content-between align-items-center">
      <h1 class="page-title fs-2">View Order</h1>
      <!-- <p class="page-subtitle small">Track and manage your recent orders.</p> -->
      <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" class="cursor-pointer" (click)="onClose()"></div>
    </div>

    <!-- Orders List -->
    <div class="d-flex flex-column gap-3" *ngIf="orderDetails">
      <div class="card custom-card border-0">
        <div class="card-body p-3">
          <!-- Order Header -->
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-3">
            <div class="d-flex align-items-center gap-3">
              <div class="avatar-circle d-flex align-items-center justify-content-center rounded-circle flex-shrink-0" style="width: 40px; height: 40px">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div>
                <h6 class="mb-1 fw-bold text-white">{{ orderDetails.Trainer?.TrainerName }} {{ orderDetails.Trainer?.TrainerLastName }} (+91 {{ orderDetails.Trainer?.MobileNumber }})</h6>
                <div class="d-flex flex-wrap gap-3 text-gray-400 small" style="font-size: 0.8rem">
                  <span class="d-flex align-items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    {{ orderDetails.CreatedDate | date }}
                  </span>
                  <!-- <span class="d-flex align-items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    {{ order.mobile }}
                  </span> -->
                </div>
              </div>
            </div>

            <!-- <div
              class="status-badge px-2 py-1 rounded-pill d-flex align-items-center gap-2"
              [class.bg-warning-subtle]="orderDetails.OrderStatus === 'Pending'"
              [class.text-warning]="orderDetails.OrderStatus === 'Pending'">
              <span class="status-dot rounded-circle" style="width: 6px; height: 6px" [class.bg-warning]="orderDetails.OrderStatus === 'Pending'"></span>
              <span class="fw-semibold" style="font-size: 0.75rem">{{ orderDetails.OrderStatus }}</span>
            </div> -->
          </div>

          <div class="mb-3">
            <div class="p-2 rounded-3" style="background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.05)">
              <div class="d-flex align-items-center gap-2">
                <div class="text-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <label class="text-gray-400 small text-uppercase fw-bold mb-0" style="font-size: 0.7rem">Delivery Address:</label>
                  <p class="mb-0 text-white small">{{ orderDetails.Center?.CenterName }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="text-gray-400 small text-uppercase fw-bold mb-2 d-block ps-1" style="font-size: 0.75rem">Ordered Items</label>
            <div class="d-flex flex-column gap-2 items-scroll-container">
              <div class="item-row p-2 rounded-3 d-flex justify-content-between align-items-center" *ngFor="let item of orderDetails.ProductOrderDetails">
                <div>
                  <div class="fw-medium text-white mb-0 small">{{ item.Product?.ProductName }}</div>
                  <div class="text-gray-400" style="font-size: 0.75rem">Size ID: {{ item.SizeID }} • Quantity: {{ item.Quantity }}</div>
                  <div class="text-gray-400 mt-1" style="font-size: 0.75rem" *ngIf="item.Student">
                    <span class="opacity-75">Student:</span> <span class="text-white ms-1">{{ item.Student?.FirstName }} {{ item.Student?.MiddleName || "" }} {{ item.Student?.LastName || "" }}</span>
                    <span *ngIf="item.Student?.MobileNo" class="ms-2 opacity-75">({{ item.Student?.MobileNo }})</span>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-3">
                  <div class="fw-bold text-primary small">₹ {{ item.Amount }}</div>
                  <ng-container *ngIf="item.OrderStatus === 'Accepted'">
                    <div class="badge bg-success-subtle text-success border border-success-subtle">Accepted</div>
                  </ng-container>

                  <ng-container *ngIf="item.OrderStatus === 'Rejected'">
                    <div class="badge bg-danger-subtle text-danger border border-danger-subtle">Rejected</div>
                  </ng-container>

                  <ng-container *ngIf="!item.OrderStatus || item.OrderStatus === 'Pending'">
                    @if(this.userTypeID === "1" || this.userTypeID === "2") {
                    <div class="d-flex gap-2">
                      <div [innerHtml]="SVG_ICONS.ABSENT_MARK_ICON() | sanitizer : 'html'" matTooltip="Reject" class="cursor-pointer" (click)="rejectItem(item.OrderDetailsID)"></div>
                      <div [innerHtml]="SVG_ICONS.PRESENT_MARK_ICON() | sanitizer : 'html'" matTooltip="Accept" class="cursor-pointer" (click)="approveItem(item.OrderDetailsID)"></div>
                    </div>
                    } @else {
                    <div class="badge bg-warning-subtle font-black border border-warning-subtle">Pending</div>
                    }
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- Total & Actions -->
          <div class="d-flex justify-content-between align-items-center pt-3 border-top border-white border-opacity-10">
            <div class="d-flex flex-column">
              <span class="text-gray-400 fw-bold" style="font-size: 0.7rem; letter-spacing: 0.5px; text-transform: uppercase">Total Amount</span>
              <span class="text-white fw-bold fs-5">₹ {{ orderDetails.TotalAmount }}</span>
            </div>

            <!-- Buttons moved -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
